if (process.env.NODE_ENV == 'production') {
    window.config.APP_URL = "http://www.guoshixiong.com";
    window.config.API_URL1 = "https://api-gsx.aunapi.com";
    window.config.API_URL2 = "https://ppt-gsx.aunapi.com";
    window.config.H5_URL = "https://api-gsx.aunapi.com/";
    window.config.APP_URL3 = 'https://api-app.guoshixiong.com';
    window.config.appid = "50001081";
    window.config.api_version = "181111";
    window.config.payResult = "https://www.guoshixiong.com/payResult?";
    window.config.gsx_dl_base = "http://ad.aunbox.cn/r.php?q=https%3A%2F%2Fitunes.apple.com%2Fcn%2Fapp%2Fid1265741262?f=";
    window.config.redirect_uri = "https://m.guoshixiong.com";
    window.config.ARTICLE = "https://www.guoshixiong.com"; //请求文章json
} else if (process.env.NODE_ENV == 'stage') {
    window.config.APP_URL = "http://www.guoshixiong.com";
    window.config.API_URL1 = "https://stage-api-gsx.guoshixiong.com";
    window.config.API_URL2 = "https://stage-ppt-gsx.guoshixiong.com";
    window.config.H5_URL = "https://stage-api-gsx.guoshixiong.com/";
    window.config.APP_URL3 = 'https://stage-api-app.guoshixiong.com';
    window.config.appid = "50001081";
    window.config.api_version = "181111";
    window.config.payResult = "https://www.guoshixiong.com/payResult?";
    window.config.gsx_dl_base = "http://ad.aunbox.cn/r.php?q=https%3A%2F%2Fitunes.apple.com%2Fcn%2Fapp%2Fid1265741262?f=";
    window.config.redirect_uri = "https://stage-m.guoshixiong.com";
    window.config.ARTICLE = "https://www.guoshixiong.com"; //请求文章json
}
else if (process.env.NODE_ENV == 'test') {
    window.config.APP_URL = "http://dev.gsx.ifonebox.cn";
    window.config.API_URL1 = "http://api-gsx.guoshixiong.test";
    window.config.API_URL2 = "http://ppt-gsx.guoshixiong.test";
    window.config.H5_URL = "http://api-gsx.guoshixiong.test";
    window.config.APP_URL3 = 'http://api-app.guoshixiong.test';
    window.config.appid = "50001081";
    window.config.api_version = "181111";
    window.config.payResult = "https://www.guoshixiong.com/payResult?";
    window.config.gsx_dl_base = "http://ad.aunbox.cn/r.php?q=https%3A%2F%2Fitunes.apple.com%2Fcn%2Fapp%2Fid1265741262?f=";
    window.config.redirect_uri = "http://m.guoshixiong.test";
    window.config.ARTICLE = "http://test.guoshixiong.com"; //请求文章json
}
else {
    window.config.APP_URL = "http://dev.gsx.ifonebox.cn";
    window.config.API_URL1 = "http://api-gsx.guoshixiong.test";
    window.config.API_URL2 = "http://ppt-gsx.guoshixiong.test";
    window.config.H5_URL = "http://api-gsx.guoshixiong.test";
    window.config.APP_URL3 = 'http://api-app.guoshixiong.cc';
    window.config.appid = "50001081";
    window.config.api_version = "181111";
    window.config.payResult = "https://www.guoshixiong.com/payResult?";
    window.config.gsx_dl_base = "http://ad.aunbox.cn/r.php?q=https%3A%2F%2Fitunes.apple.com%2Fcn%2Fapp%2Fid1265741262?f=";
    window.config.redirect_uri = "http://m.guoshixiong.test";
    window.config.ARTICLE = "http://test.guoshixiong.com"; //请求文章json
}



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 1wn0
// module chunks = 1